import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';
import TableHead from '@mui/material/TableHead/TableHead';
import TableBody from '@mui/material/TableBody/TableBody';
import * as dates from '@simplybenefits/sb-dates';
import { fonts } from '../../../theme/index.js';
import MessageCard from '../../../components/Cards/MessageCard.js';
import Bubble from '../../../components/Bubble.js';
import Button from '../../../components/Button.js';
import Text from '../../../components/Text.js';
import PlanDesignForm from './PlanDesignForm.js';
import ContentBlock from '../../../components/Divs/ContentBlock.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import StyledTable from '../../../components/StyledTable.js';
import StyledTableRow from '../../../components/StyledTableRow.js';
import StyledTableCell from '../../../components/StyledTableCell.js';
import Loader from '../../../components/Loader.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class Revisions extends Component {
  state = {
    revisions: [],
    selectedRevision: null
  };
  async componentDidMount() {
    const revisions = await this.props.getPlanDesignRevisions(this.props.selectedDesignID);
    this.setState({
      revisions
    });
  }
  _selectRevision = async revisionID => {
    const selectedRevision = await this.props.getSinglePlanDesignRevision(revisionID);
    this.setState({
      selectedRevision: selectedRevision
    });
  };
  _revertToRevision = async () => {
    delete this.state.selectedRevision.changedBy;
    delete this.state.selectedRevision.effectiveDate;
    delete this.state.selectedRevision.revisionID;
    const data = {
      ...this.props.designs[this.props.selectedClassID][this.props.selectedDesignID],
      ...this.state.selectedRevision
    };

    // TODO: if we don't want to actually save the revision to the current plan design, then remove this function call
    await this.props.saveDesign(data);
    await this.props.revertToRevision(this.props.selectedClassID, this.props.selectedDesignID, data);

    // eslint-disable-next-line no-empty-function
    setTimeout(() => {}, 5000);
    this.props.goBack();
  };
  _handleGoBack = () => {
    if (this.state.selectedRevision) {
      this.setState({
        selectedRevision: null
      });
      return null;
    }
    return this.props.goBack();
  };
  render() {
    const {
      whitelabel,
      designs,
      selectedClassID,
      selectedDesignID
    } = this.props;
    const styles = {
      headerTitleBlock: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      backBtn: {
        minWidth: 30,
        padding: 2,
        marginRight: 5,
        marginLeft: -5
      },
      tableHeading: {
        paddingTop: 10,
        paddingBottom: 10,
        fontFamily: fonts.type.heading
      },
      tableCell: {
        paddingTop: 10,
        paddingBottom: 10,
        fontFamily: fonts.type.light
      }
    };
    if (this.props.loader?.isLoading) {
      return /*#__PURE__*/React.createElement(Loader, {
        isContainer: true
      });
    }
    return /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(HeaderDiv, null, /*#__PURE__*/React.createElement("div", {
      style: styles.headerTitleBlock
    }, /*#__PURE__*/React.createElement(Button, {
      style: styles.backBtn,
      onClick: this._handleGoBack,
      transparent: true
    }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0"
    }, i18n.t(tokens.titles.revisions))), /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.locale === "fr" ? designs[selectedClassID][selectedDesignID].title.replace("Design", "Conception") : designs[selectedClassID][selectedDesignID].title,
      isSelected: true,
      clickable: false
    })), this.state.selectedRevision ? /*#__PURE__*/React.createElement(React.Fragment, null, !this.props.overrideModularView && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.quotes.revisionReview, {
        revisionID: this.state.selectedRevision.revisionID
      }),
      subtitle: i18n.t(tokens.labels.quotes.passedRevisions),
      btn: !this.props.isMasterSite && this.props.currentAccountMeta.state > 3 ? null : i18n.t(tokens.buttons.revert),
      btnName: i18n.t(tokens.buttons.revert),
      btnOnClick: this._revertToRevision
    }), /*#__PURE__*/React.createElement(PlanDesignForm, {
      isMasterSite: this.props.isMasterSite,
      selectedDesignID: selectedDesignID,
      selectedClassID: selectedClassID,
      designs: designs,
      whitelabel: whitelabel,
      revision: this.state.selectedRevision,
      accountMeta: this.props.currentAccountMeta
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, !this.state.revisions || this.state.revisions.length === 0 ? /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.quotes.noSavedRevisions)) : /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(StyledTableRow, null, /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, i18n.t(tokens.labels.quotes.revisionID)), /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, i18n.t(tokens.labels.quotes.design)), /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, i18n.t(tokens.labels.quotes.changedBy)), /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }, i18n.t(tokens.labels.quotes.changedDate)), /*#__PURE__*/React.createElement(StyledTableCell, {
      style: styles.tableHeading
    }))), /*#__PURE__*/React.createElement(TableBody, null, this.state.revisions.map(revision => {
      let changedBy = revision.changedByType;
      if (i18n.locale === 'fr') {
        if (changedBy === 'Advisor') {
          changedBy = 'Conseiller';
        }
        if (changedBy === 'Support') {
          changedBy = 'Soutien';
        }
      }
      return /*#__PURE__*/React.createElement(StyledTableRow, {
        key: revision.revisionID
      }, /*#__PURE__*/React.createElement(StyledTableCell, {
        style: styles.tableCell
      }, revision.revisionID), /*#__PURE__*/React.createElement(StyledTableCell, {
        style: styles.tableCell
      }, i18n.locale === "fr" ? revision.title.replace("Design", "Conception") : revision.title), /*#__PURE__*/React.createElement(StyledTableCell, {
        style: styles.tableCell
      }, `${revision.changedByName} (${changedBy})`), /*#__PURE__*/React.createElement(StyledTableCell, {
        style: styles.tableCell
      }, dates.getLocalDisplay(revision.effectiveDate, 'lll', i18n.locale)), /*#__PURE__*/React.createElement(StyledTableCell, {
        style: styles.tableCell
      }, /*#__PURE__*/React.createElement(Button, {
        transparent: true,
        onClick: () => {
          this._selectRevision(revision.revisionID);
        }
      }, i18n.t(tokens.buttons.view))));
    })))));
  }
}

/**
 * 
 * @param {*} state 
 * @returns 
 */
const mapStateToProps = state => ({
  loading: state.quotes.loading
});
export default connect(mapStateToProps)(Revisions);